import React, { useState, useEffect, useRef, use } from "react";
import { createPortal } from "react-dom";
import anonymous from "../../../../assets/images/anonymous.jpg";
import { IoBagCheckOutline } from "react-icons/io5";
import { BiDetail } from "react-icons/bi";
import { motion, AnimatePresence, useTime } from "framer-motion";
import { IoIosArrowBack } from "react-icons/io";
import CargoService from "../../../../services/Cargo";
import AcceptModal from "../../../../Modals/accept modal/AcceptModal";
import { useDispatch } from "react-redux";
import { showToast } from "../../../../redux/slices/toastSlice";
import { type } from "@testing-library/user-event/dist/type";
import DriversSkeleton from "./DriverListSkelation";
import EmptyStateMyLoads from "../../../../Modals/empty list/EmptyList";
import { FaUser } from "react-icons/fa";
function DetailPopover({ triggerClassName = "", children, content }) {
  const triggerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const enterTimeout = useRef(null);
  const leaveTimeout = useRef(null);



  const updatePos = () => {
    const rect = triggerRef.current?.getBoundingClientRect();
    if (!rect) return;
    setPos({
      top: rect.bottom + window.scrollY + 8,
      left: rect.left + window.scrollX,
    });
  };

  useEffect(() => {
    if (!open) return;
    const onScrollResize = () => updatePos();
    window.addEventListener("scroll", onScrollResize, true);
    window.addEventListener("resize", onScrollResize);
    return () => {
      window.removeEventListener("scroll", onScrollResize, true);
      window.removeEventListener("resize", onScrollResize);
    };
  }, [open]);

  const onMouseEnter = () => {
    clearTimeout(leaveTimeout.current);
    updatePos();
    enterTimeout.current = setTimeout(() => setOpen(true), 60);
  };

  const onMouseLeave = () => {
    clearTimeout(enterTimeout.current);
    leaveTimeout.current = setTimeout(() => setOpen(false), 100);
  };

  if (typeof document === "undefined") {
    return (
      <div
        ref={triggerRef}
        className={triggerClassName}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>
    );
  }

  return (
    <>
      <div
        ref={triggerRef}
        className={triggerClassName}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {children}
      </div>

      {createPortal(
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: -6 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -6 }}
              transition={{ duration: 0.16 }}
              style={{
                position: "absolute",
                top: pos.top,
                left: pos.left,
                zIndex: 9999,
              }}
              onMouseEnter={() => clearTimeout(leaveTimeout.current)}
              onMouseLeave={onMouseLeave}
              className="bg-white shadow-2xl border border-gray-200 rounded-xl text-gray-700 min-w-[220px] px-6 py-3 pointer-events-auto"
            >
              {content}
            </motion.div>
          )}
        </AnimatePresence>,
        document.body
      )}
    </>
  );
}

export default function DriverList({ setView,id }) {
  const [drivers,setDrivers]=useState([])
  const [data, setData] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isConfirm,setIsConfirm]=useState(false)
  const [acceptModal,setAcceptModal]=useState(false)
  const dispatch=useDispatch()
  const [openBottomSheet,setOpenBottomSheet]=useState(false)
  const [loading,setLoading]=useState(false)


  async function getDriverList(){
    try{
      setLoading(true)

      const res=await CargoService.getDriverList({cargo:id})
      setDrivers(res?.data?.data)

    }catch(err){
      

      console.log(err)
    }finally{
      setLoading(false)
    }
  }
  useEffect(()=>{
    getDriverList()
  },[id])

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  console.log(drivers)





  async function acceptDriver(){
    setIsConfirm(true)
    try{
      console.log(id)
      const res=await CargoService.acceptDriver({cargo:id , driver:data._id})
      console.log(res)
      if(res.status===200){
        dispatch(showToast({message:"راننده مورد نظر با موفقیت پذیرش شد",type:"success"}))
      }
      
    }catch(err){
      
      dispatch(showToast({message:"خطا در پذیرش راننده",type:"error"}))
      console.log(err)
    }finally{
      setIsConfirm(false)
      setTimeout(() => {
        setAcceptModal(false)
      }, 200);
    }
  }

  console.log(drivers)

  if(loading)return <DriversSkeleton/>

  return (  
  
    <>
    {
      
      drivers?.length ==0 ?
      <div className="flex flex-col h-screen items-center justify-center w-full">

     
      <EmptyStateMyLoads
            ShowButton={false}
            colorContent="text-special"
            title="راننده ای برای بار شما یافت نشد"
            subtitle="تاکنون راننده ای بار شما را پذیرش نکرده است" 
            icon={FaUser}
           >
        </EmptyStateMyLoads>
        </div>
      :
<>
      <AcceptModal
      title={"آیا از تایید راننده مورد نظر اطمینان کامل دارید ؟"}
      open={acceptModal}
      onClose={()=>{setAcceptModal(false)}}
      action={acceptDriver}
      isConfrim={isConfirm}
      ></AcceptModal>
  
      <div className="w-full h-full flex flex-col gap-5">
        {/* Header */}
        <div className="flex flex-col gap-4 w-full">
          <div className="flex justify-end w-full">
            <div
              onClick={() => setView("load")}
              className="cursor-pointer flex flex-row gap-1 text-[14px] text-special"
            >
              <p>بازگشت</p>
              <IoIosArrowBack className="text-special" size={20} />
            </div>
          </div>
  
          <div className="flex flex-row justify-between w-full items-center">
            <p className="lg:text-[18px] text-[14px] font-medium">لیست رانندگان</p>
            <p className="lg:text-[14px] text-[12px] text-gray-400">
              {drivers.length} مورد یافت شد!
            </p>
          </div>
        </div>
  
        {/* List */}
        <motion.div
          className="flex px-5 flex-col w-full divide-y divide-gray-300 overflow-y-auto"
          initial="hidden"
          animate="visible"
          variants={{ visible: { transition: { staggerChildren: 0.05 } } }}
        >
          {drivers?.map((driver) => (
            <motion.div
              key={driver._id}
              className="flex flex-row justify-between items-center py-2 px-1"
              variants={{
                hidden: { opacity: 0, y: 10 },
                visible: {
                  opacity: 1,
                  y: 0,
                  transition: { type: "spring", stiffness: 300, damping: 25 },
                },
              }}
              whileHover={{ scale: 1.01 }}
            >
              <div className="flex items-center gap-2">
                <img
                  src={anonymous}
                  className="rounded-full lg:w-[35px] w-[25px]"
                  alt={driver.name}
                />
                <p className="font-normal lg:text-[16px] text-[12px]">
                  نام و نام خانوادگی : {driver.firstname + " " +driver.lastname}
                </p>
              </div>
  
              <div className="flex flex-row lg:gap-5 gap-2 items-center">
                <div  
                  onClick={()=>{setAcceptModal(true)
                    setData(driver)
                }}
                className="flex gap-1 text-special cursor-pointer">
                  <IoBagCheckOutline
                  size={18} />
                  <p className="lg:text-[14px] text-[12px] hidden lg:block">پذیرش</p>
                </div>
  
                {isMobile ? (
                  <div
                    className="flex gap-1 text-gray-900 cursor-pointer"
                    onClick={() => {setData(driver) 
                      setOpenBottomSheet(true)
                    }}
                  >
                    <BiDetail
           
                     size={18} />
                    <p className="lg:text-[14px] text-[12px] hidden lg:block">جزییات</p>
                  </div>
                ) : (
                  <DetailPopover
                    triggerClassName="relative inline-block"
                    content={
                      <div>
                        <p className="font-medium text-[16px]">اطلاعات راننده</p>
                        <p className="text-[14px] mt-2">ماشین : {driver?.cartype ? driver?.cartype?.label + "-" + driver?.cartype?.name : "-"} </p>
                        <p className="text-[14px] mt-2">شماره تماس : 0{driver?.mobile}</p>
                      </div>
                    }
                  >
  
                    <div className="flex gap-1 text-gray-900 cursor-pointer">
                      <BiDetail size={18} />
                      <p className="lg:text-[14px] text-[12px]">جزییات</p>
                    </div>
                  </DetailPopover>
                )}
              </div>
            </motion.div>
          ))}
        </motion.div>
  
  
        {isMobile &&
          createPortal(
            <AnimatePresence>
              {data && openBottomSheet && (
                <>
                  <motion.div
                    className="fixed inset-0 bg-black/40 z-40"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    onClick={() => setData(null)}
                  />
  
                  <motion.div
                    className="fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-2xl p-6 shadow-lg"
                    initial={{ y: "100%" }}
                    animate={{ y: 0 }}
                    exit={{ y: "100%" }}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  >
                    <div className="flex justify-between items-center">
                      <p className="font-medium text-[16px]">اطلاعات راننده</p>
                      <button
                        className="text-gray-500 text-sm"
                        onClick={() => {setData(null)
                           setOpenBottomSheet(false)}}
                      >
                        بستن
                      </button>
                    </div>
                    <p className="text-[14px] mt-4">ماشین : {data?.cartype ? data?.cartype?.label + " " + data?.cartype?.name : "-"}</p>
                    <p className="text-[14px] mt-2">شماره تماس : 0{data?.mobile}</p>
                  </motion.div>
                </>
              )}
            </AnimatePresence>,
            document.body
          )}
      </div>
      </>
    }
   
    </>
  );
}
